import TempResponsiveScreen from './TempResponsiveScreen'

export default TempResponsiveScreen
